import { enums } from "../../shim/jsbridge";
import { asEnum } from "./EnumObject";

const result = asEnum(enums.threat_status);

export const classificationByLabels = result.byLabels;
export const classificationByValues = result.byValues;

export const getClassificationByLabels = label =>
  classificationByLabels[label?.toUpperCase()];

export const getClassificationByValue = value => classificationByValues[value];

export const threatStatusMapping = Object.keys(classificationByLabels); // returns array with all RL threat status names

export const classificationMatchesRlClassification = classification =>
  threatStatusMapping.includes(classification.toString().toUpperCase());
